/** Build a complete display name: first, father, grand, family. Skip only exact duplicate parts. */
export function formatEmployeeDisplayName(emp: {
  empFirstNameEn?: string
  empSecondNameEn?: string
  empLastNameEn?: string
  empFatherNameEn?: string
  empGrandNameEn?: string | null
  empFamilyNameEn?: string
  empCode?: string
}): string {
  const ordered = [
    emp.empFirstNameEn,
    emp.empFatherNameEn,
    emp.empGrandNameEn,
    emp.empFamilyNameEn ?? emp.empLastNameEn,
    emp.empSecondNameEn,
  ]
    .map((p) => String(p || '').trim())
    .filter(Boolean)

  const unique: string[] = []
  for (const part of ordered) {
    if (unique.some((u) => u.toLowerCase() === part.toLowerCase())) continue
    unique.push(part)
  }

  return unique.join(' ').trim() || emp.empCode || ''
}

/** "Ahmed Ali Ahmed Ali" or "Ahmed Ahmed" → single name. */
export function collapseDuplicatedFullName(name?: string | null): string {
  const t = String(name || '').trim().replace(/\s+/g, ' ')
  if (!t) return ''

  const parts = t.split(' ')
  if (parts.length >= 2 && parts.length % 2 === 0) {
    const half = parts.length / 2
    const a = parts.slice(0, half).join(' ')
    const b = parts.slice(half).join(' ')
    if (a.toLowerCase() === b.toLowerCase()) return a
  }

  const out: string[] = []
  for (const p of parts) {
    if (out.length && out[out.length - 1].toLowerCase() === p.toLowerCase()) continue
    out.push(p)
  }
  return out.join(' ')
}
